export default __webpack_public_path__ + "static/media/hasay6.fd158cb0.jpg";